
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

const colors = [
  'linear-gradient(90deg, #CFD9DF 0%, #E2EBF0 100%)',
  'linear-gradient(90deg, #E6E9F0 0%, #EEF1F5 100%)',
  'linear-gradient(90deg, #FDFBFB 0%, #DCE5FF 100%)',
  'linear-gradient(90deg, #E6E9F0 0%, #EEF1F5 100%)',
  'linear-gradient(90deg, #DDE7FF 0%, #EEF1F5 100%)',
  'linear-gradient(90deg, #E6E9F0 0%, #EEF1F5 100%)',
  'linear-gradient(90deg, #E6FFFF 0%, #EEF1F5 100%)',
  'linear-gradient(90deg, #D1D1D1 0%, #EEF1F5 100%)',
];

export default BaseCmsBlock.extend({
  name: 'TiresWheelsBlock',

  methods: {
    getStyleCard: function (index) {
      const list = [
        `background: ${colors[index % 8]}`,
      ];

      return list.join(';');
    },
  },
});
